/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';
import filter from 'lodash/filter';

/**
 * Validates a set of existing values and fails the value is not unique.
 * @template R
 */
export class UniqueValueValidator<R> extends Validator<string, R> {
  protected values: Array<unknown> = [];
  protected modifier: (v: unknown) => unknown = (v) => v;
  protected allowedCount = 1;

  /**
   * Set the allowed count of matches (0) means no existing matches.
   * @param count The allowed count.
   */
  public setAllowedCount(count: number): void {
    this.allowedCount = count;
  }

  /**
   * Set values to be compared as unique.
   * @param values The values.
   * @param excludes Any values to be excluded for comparison.
   */
  public setValues(values: Array<unknown>, excludes: Array<unknown> = []): void {
    this.values = filter(values, (v): boolean => !excludes.includes(v));
  }

  /**
   * Allows values to be modified before they are compared.
   * @param m Value modifier function.
   */
  public setValueModifier(m: (v: unknown) => unknown): void {
    this.modifier = m;
  }

  public doValidate(value: unknown): boolean {
    const modifiedValue = this.modifier(value);
    return filter(this.values, (v): boolean => v === modifiedValue).length <= this.allowedCount;
  }
}
